import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import SnapAds from './SnapAds';
import TikTokLive from './TikTokLive';
import GoogleAdsLive from './GoogleAdsLive';
import EmptyState from '../components/EmptyState';

const PLATFORMS = [
  { key: 'snapchat', color: '#FFFC00', textColor: '#000' },
  { key: 'tiktok', color: '#EE1D52', textColor: '#fff' },
  { key: 'google', color: '#4285F4', textColor: '#fff' },
  { key: 'instagram', color: '#E1306C', textColor: '#fff' },
  { key: 'x', color: '#1DA1F2', textColor: '#fff' },
];

function Channels() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const initialPlatform = PLATFORMS.some(p => p.key === searchParams.get('platform'))
    ? searchParams.get('platform')
    : 'snapchat';
  const [platform, setPlatform] = useState(initialPlatform);

  return (
    <div>
      {/* Platform tabs */}
      <div className="channel-tabs">
        {PLATFORMS.map(p => (
          <button
            key={p.key}
            className={`channel-tab ${platform === p.key ? 'active' : ''}`}
            onClick={() => setPlatform(p.key)}
            style={platform === p.key ? { background: p.color, color: p.textColor, borderColor: p.color } : {}}
          >
            {t('channel_' + p.key)}
          </button>
        ))}
      </div>

      {/* Snapchat — single unified view */}
      {platform === 'snapchat' && <SnapAds />}

      {/* TikTok */}
      {platform === 'tiktok' && <TikTokLive />}

      {/* Google Ads */}
      {platform === 'google' && <GoogleAdsLive />}

      {/* Instagram */}
      {platform === 'instagram' && (
        <div className="card" style={{ marginTop: 0 }}>
          <EmptyState icon="📸" title="Instagram — Coming Soon" subtitle={t('channelComingSoonDesc')} />
        </div>
      )}

      {/* X (Twitter) */}
      {platform === 'x' && (
        <div className="card" style={{ marginTop: 0 }}>
          <EmptyState icon="𝕏" title="X (Twitter) — Coming Soon" subtitle={t('channelComingSoonDesc')} />
        </div>
      )}
    </div>
  );
}

export default Channels;
